export default {
  manage_crew: "Crew",
  manage_crew_crewMembers: "Crew Members",
  manage_crew_units: "Vehicles",
  manage_crew_crews_name: "Name",
  manage_crew_crews_reAssign: "Re-Assign",
  manage_crew_units_crewAssigned: "Crew Assigned",
  manage_crew_units_label: "Vehicle",
  manage_crew_units_assignCrew: "Assign Crew",
  manage_crew_units_editCrew: "Edit Crew",
  manage_crew_crews_assignedTo: "Assigned To",
  manage_crews_unitsExported: "The export has been generated successfully.",
  manage_crews_search_name_assignedTo: "Search by Name or Assigned To",
};
